import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Typography from '@mui/material/Typography'

import { StyledError } from '../../../../theme/components/StyledError'
import { useUpdateSubprocesForEntity } from '../../hooks/useUpdateSubprocesForEntity'
import type { Subproces } from '../../types/Subproces'
import { getStatusLabelForType } from '../../util/subproces-util'

interface Props {
  subproces: Subproces
  onClose: () => void
}

export const ResumeNetcheck = ({ subproces, onClose }: Props) => {
  const { mutate: updateSubprocesForEntity, error } =
    useUpdateSubprocesForEntity()

  const onSubmitClick = () => {
    const proces: Partial<Subproces> = {
      _id: subproces._id,
      status: 'in_progress',
    }

    const body = {
      entity: subproces.entity,
      subprocesInfo: proces,
    }

    updateSubprocesForEntity(body, { onSuccess: () => onClose() })
  }

  return (
    <>
      <DialogContent>
        <StyledError error={error} />
        <Typography>
          Wilt u dit netcheckproces hervatten? Dit zet de status terug naar{' '}
          <em>{getStatusLabelForType(subproces.type, 'in_progress')}</em>.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose} autoFocus>
          Annuleren
        </Button>
        <Button onClick={onSubmitClick} variant={'contained'}>
          Ja
        </Button>
      </DialogActions>
    </>
  )
}
